import { useNavigate } from 'react-router-dom';
import type { Recommendation } from '../../../amplify/functions/recommendations/handler';
import Button from '@/components/ui/Button';

interface RecommendCardProps {
  rec: Recommendation;
  onAddToCellar?: (rec: Recommendation) => void;
  onDismiss?: (rec: Recommendation) => void;
}

export default function RecommendCard({ rec, onAddToCellar, onDismiss }: RecommendCardProps) {
  const navigate = useNavigate();

  return (
    <div className="rec-card">
      <div className="rec-card-header">
        <div className="rec-card-info">
          <p className="rec-card-name">{rec.name}</p>
          {rec.producer && <p className="rec-card-producer">{rec.producer}</p>}
          {rec.vintage && <p className="rec-card-vintage">{rec.vintage}</p>}
        </div>
        <div className="rec-card-score">
          <span className="rec-score-number">{rec.matchScore}</span>
          <span className="rec-score-label">% match</span>
        </div>
      </div>

      <p className="rec-card-reason">{rec.reason}</p>

      {rec.foodNote && (
        <p className="rec-card-food">
          <span className="rec-food-icon">🍽</span> {rec.foodNote}
        </p>
      )}

      {rec.retailerHint && (
        <p className="rec-card-retailer">Available at: {rec.retailerHint}</p>
      )}

      <div className="rec-card-actions">
        <span className={`rec-source-badge rec-source-${rec.source}`}>
          {rec.source === 'cellar' ? 'In your cellar' : 'Buy'}
        </span>
        <div className="rec-card-buttons">
          {rec.wineId && (
            <Button size="sm" variant="ghost" onClick={() => navigate(`/wine/${rec.wineId}`)}>
              Details
            </Button>
          )}
          {rec.source === 'buy' && onAddToCellar && (
            <Button size="sm" variant="secondary" onClick={() => onAddToCellar(rec)}>
              + Cellar
            </Button>
          )}
          {onDismiss && (
            <Button size="sm" variant="ghost" onClick={() => onDismiss(rec)}>
              Not for me
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
